import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { BreakpointMobile, theme } from "../Layout/GlobalStyle"
import Button from "@material-ui/core/Button"
import { makeStyles } from "@material-ui/core/styles"
import PropTypes from "prop-types"
import { Link } from "gatsby"
import { APP_PAGE } from "../Layout/routes"

const useStyles = makeStyles(theme => ({
  CTA: {
    fontFamily: "Roboto",
    fontWeight: "bold",
    backgroundColor: "#EB6848",
    "&:hover": {
      backgroundColor: "#EB6848",
    },
  },
  activeHeart: {
    color: "#e91e63",
  },
}))

const Container = styled.div`
  width: 100%;
  max-width: ${props => props.maxWidth && `${props.maxWidth}`};
  height: 380px;

  margin-top: 20px;
  /* background: url(${props =>props.theme.advertising.agent99SprayBottleBackdrop}); */
  
  margin-bottom: 20px;
  position: relative;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 4px;
  background-position: 50%;
  transition: 0.2s ease-in-out;

  .ad-logo{
    opacity: 0.5;
  }

  @media only screen and (max-width: ${BreakpointMobile + "px"}) {
    width: 100%;
    height: 400px;
    margin-left: auto;
    margin-right: auto;
    max-width: ${BreakpointMobile + "px"};
  }

  :hover {
    transition: 0.2s ease-in-out;

    .overlay {
      transition: 0.2s ease-in-out;

      background: rgba(0, 0, 0, 0.6);
    }
  }
  .overlay {
    position: absolute;
    border-radius: 4px;
    transition: 0.2s ease-in-out;
    width: 100%;
    overflow: hidden;
    padding: 20px;
    height: inherit;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    background: rgba(0, 0, 0, 0.7);

    flex-direction: column;
    align-items: flex-start;
  }
`

const MessageHeading = styled.h1`
  font-size: 26px;
  font-family: var(--Font1);
  line-height: 33px;
  color: white;
  margin-bottom: 0px;
  margin-top: 10px;
  b {
    color: rgb(255, 91, 2);
  }

  text-shadow: 0px 3px 6px rgba(0, 0, 9, 0.16);
`

const Message = styled.p`
  font-size: 24px;
  font-family: var(--Font2);
  line-height: 28px;
  color: white;

  b {
    color: rgb(255, 91, 2);
  }

  text-shadow: 0px 3px 6px rgba(0, 0, 9, 0.16);
`
const UnorderedList = styled.ul`
  font-size: 22px;
  font-family: var(--Font2);
  line-height: 26px;
  color: white;
  padding-left: 20px;

  b {
    color: rgb(255, 91, 2);
  }

li{
  font-family: var(--Font2);
  margin-bottom: 10px;
}
  text-shadow: 0px 3px 6px rgba(0, 0, 9, 0.16);
`

function Advertisment({ maxWidth, maxHeightDesktop }) {
  const classes = useStyles()

  return (
    <Link
    target={"_blank"}
    to={APP_PAGE}
  >
    <Container maxHeightDesktop={maxHeightDesktop} maxWidth={maxWidth}>
      <div className="overlay">
        {/* <img
          className={"ad-logo"}
          alt="Agent 99 safe, environmentally responsible sanitizer"
          width={100}
          height={"auto"}
          src={theme.logos.agent99Logo}
        /> */}

        <div className={"message-wrapper"}>
          <MessageHeading>
            We just released our app
          </MessageHeading>
          <UnorderedList>
            <li>Keep track of your favorite herbs</li>
            <li>Vote on your favorite remedies</li>
            <li><b>Find natural remedies based on your symptoms using our symptom checker</b></li>
          </UnorderedList>
        

        </div>

     
        <footer>
         
            <Button
              disableElevation
              variant={"contained"}
              color="secondary"
              className={classes.CTA}
            >
              Download
            </Button>
        </footer>
      </div>
    </Container>
    </Link>

  )
}

Advertisment.defaultProps = {
  maxWidth: "600px",
  maxHeightDesktop: "400px"
}

Advertisment.propTypes = {
  maxWidth: PropTypes.string,
}

export default Advertisment
